<template>
  <div id="app">
	<div class="header">
		<a class="logo" href="https://superawesomelab.com/">
			<img class="logo" alt="Super Awesome Lab's logo" src="./assets/logo.svg">
		</a>
		<!--<img class="logo" alt="Super Awesome Lab's logo" src="./assets/logo.svg">-->
		<div class="menu-items">
			<a v-if="$route.path !== '/landing-page-critique'" href="#services">Services</a>
			<a v-if="$route.path !== '/landing-page-critique'" href="#work">Work</a>
			<a v-if="$route.path !== '/landing-page-critique'" href="#values">Values</a>
		</div>
		<a href="https://super-awesome-lab.typeform.com/to/PK98i81C" class="cta">
			Get in touch
		</a>
	</div>
    <!--<HomePage msg="Welcome to Your Vue.js App"/>-->
	<router-view></router-view>
  </div>
</template>

<script>
import HomePage from './components/HomePage.vue'

export default {
  name: 'App',
  components: {
    //HomePage
  }
}
</script>

<style>
	@import './assets/css/style.css';
</style>
